import React from "react";

const CommonCountMultiSelect = ({ count, bgColor, textColor }) => {
  return (
    <div
      className={`flex items-center justify-center h-icon-lg min-w-[var(--icon-lg)] rounded-full ${bgColor} ${textColor} text-font-md font-semibold text-center px-padding-sm py-padding-xs`}
    >
      <div className="cursor-default">
        <span>{count}</span>
      </div>
    </div>
  );
};

export default CommonCountMultiSelect;
